module.exports = __webpack_public_path__ + "img/logo.0c7cfb70.png";